import { render, staticRenderFns } from "./user_index.vue?vue&type=template&id=4fbf9478&"
import script from "./user_index.vue?vue&type=script&lang=js&"
export * from "./user_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fbf9478')) {
      api.createRecord('4fbf9478', component.options)
    } else {
      api.reload('4fbf9478', component.options)
    }
    module.hot.accept("./user_index.vue?vue&type=template&id=4fbf9478&", function () {
      api.rerender('4fbf9478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/topicos/user_index.vue"
export default component.exports